import { Injectable, signal } from '@angular/core';
import type { TransactionHeaderModel } from '../api/auth.models';

@Injectable({ providedIn: 'root' })
export class TransactionSessionService {
  private readonly selectedTransactionSignal = signal<TransactionHeaderModel | null>(null);
  setSelectedTransaction(transaction: TransactionHeaderModel): void {
    this.selectedTransactionSignal.set(transaction);
  }

  getSelectedTransaction(): TransactionHeaderModel | null {
    return this.selectedTransactionSignal();
  }

  clearSelectedTransaction(): void {
    this.selectedTransactionSignal.set(null);
  }
}
